import {PlanbordQueryFilter} from '@/util/PlanbordQueryFilter';

export default class RoosterplanningUrlBuilder {
    public static globalTenant: string | null = null;

    public static getHostUrl(): string | null {
        const tenant: string | null = RoosterplanningUrlBuilder.getTenant();
        if (!tenant) {
            return null;
        }

        return import.meta.env.VITE_ROOSTERPLANNING_HOST.replace('{tenant}', tenant);
    }

    public static getApiUrl(): string | null {
        const baseUrl: string | null = RoosterplanningUrlBuilder.getHostUrl();
        if (!baseUrl) {
            return null;
        }

        return baseUrl + import.meta.env.VITE_ROOSTERPLANNING_API_PATH;
    }

    public static getTenant(): string | null {
        if (RoosterplanningUrlBuilder.globalTenant && RoosterplanningUrlBuilder.globalTenant.length > 0) {
            return RoosterplanningUrlBuilder.globalTenant;
        }

        const urlParams: URLSearchParams = new URLSearchParams(document.location.search);
        if (urlParams.has('tenant')) {
            return urlParams.get('tenant');
        } else if (urlParams.has('state')) {
            return PlanbordQueryFilter.getFromState(urlParams).tenant ?? null;
        }

        return null;
    }
}
